import React, { Component, Fragment } from 'react';


import classnames from 'classnames';
import {blue,pink,green} from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, DialogTitle } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
//import ResourceView from '../view/ResourceView';
import { PDFIcon, CSVIcon, JSONIcon, ZIPIcon} from '../icons';
import Download from '../../ajax/download';
import ClosableBar from '../dialogs/ClosableBar';

// import {bizpost} from '../../ajax';
// import {getNames} from '../../app/views/txnconfig';
import moment from 'moment';

const s:any = {
  root: {
    //width: '100%',
    flex: '1 1 auto',
    background: 'background.paper',
  },
  heading: {
    fontSize: 'typography.pxToRem(15)',
  },
  secondaryHeading: {
    fontSize: 'typography.pxToRem(15)',
    color: 'text.secondary',
  },
  secondaryHeading2: {
    fontSize: 'typography.pxToRem(15)',
    color: blue[600], //theme.palette.text.secondary,
  },
  topheading: {
    fontWeight:'bold',
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20,
  },
  details: {
    alignItems: 'center',
  },
  column: {
    flexBasis: '50%',
  },
  gridtitle: {
    fontSize: 'typography.pxToRem(15)',
    color: pink['500'],
    fontWeight:'bold',
  },
  gridroot: {
    width: '100%',
  },
  gridrow: {
    display: 'flex',
    width: 600,
    border: '1px solid #eeeeee',
    textAlign: 'left',
  },
  gridcolumnauto: {
    flexBasis: 'fill',
    textAlign: 'left',
    borderRight: '1px solid #eeeeee',
  },
  gridcolumn30: {
    flexBasis: 'auto',
    width: '200px',
    textAlign: 'left',
    borderRight: '1px solid #eeeeee',
  },
  gridcontent: {
    textAlign: 'left',
    paddingLeft: '20px',
  },
  dcolumn: {
    width: '100%',
    display: 'flex',
    flexBasis: '50%',
  },
  helper: {
    borderLeft: `2px solid gray`,
    p: 2,
  },
  link: {
    color: 'primary', //['500'],
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  iconsroot: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  customicon: {
    m: 2,
    color: pink["500"]
  },
  iconHover: {
    m: 2,
    '&:hover': {
      color: green[200],
    },
  },
  
};

class Preview extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      loaded:false,
      views:[],
      count:0,
      data: []
    };
  }

  //TODO: Move this to src/app/services and keep a dummy failsafe version here.
  formatDate = (stamp:any) => {
    return moment(stamp,'YYYY-MM-DD HH:mm:ss.SSSSSS').format('DD-MMM-YYYY HH:mm');
  }
  //processTransaction = (record:any) => {
  processRecord = (record:any) => {
    // const agent = {title:'Agent',data:[]};
    // const config = {title:'Configuration',data:[]};
    // const payload = {title:'Payload',data:[]};
    // const request = {title:'Request',data:[]};
    // const response = {title:'Response',data:[]};

    // const names = getNames('txn')(true);

    const {req,res} = record;
    const {aci,acn,acc,enm,eni,enc} = record; //activity
    const {evn,evc,vti,evi,rfn,tri,dcd,stp,amt} = record; //event
    const {cnm,coc,mbn,idn,csn,eml} = record; //customer
    const {tdt,cuc,dtl} = record; //transaction
    const {} = record; //compliance

    // const request = [
    //   {t:'Request ID',v:rqi},
    //   {t:'Service',v:xtc},
    //   {t:'Channel',v:cln},
    //   {t:'Status',v:xsc},
    // ];

    // const event = [
    //   {t:'Event',v:evn},
    //   {t:'Reference',v:rfn},
    //   {t:'Track ID',v:tri},
    //   {t:'Created',v:dcd}
    // ];

    const customer = [
      {t:'Customer Name',v:csn},
      {t:'Email',v:eml},
      {t:'Mobile',v:mbn},
      {t:'ID Number',v:idn},
    ];

    const activity = [
      {t:'Activity Name',v:acn},
      {t:'Activity Code',v:acc},
      {t:'Entity',v:enm},
      {t:'Entity Code',v:enc},
    ];

    const event = [
      {t:'Reference ID',v:rfn},
      {t:'Track ID',v:tri},
      {t:'Created',v:this.formatDate(dcd)},
      {t:'Date Created', v:this.formatDate(stp)},
      // {t:'Currency',v:cuc},
      // {t:'Amount',v:amt},
      // {t:'Details',v:dtl},
    ];

    if(amt && evi ===2) event.push( {t:'Amount',v:`GHS ${(+amt).toFixed(2)}`} );

    // const compliance = [
    //   {t:'Status',v:nsc}
    // ]

    const rtn = [
     {title:'Activity',data:activity},
     {title:'Events',data:event},
     {title:'Customer',data:customer},
    //  {title:'Transaction',data:transaction},
    //  {title:'Compliance',data:compliance},
    ];

    return rtn;
  }

//   procRecord = (record:any) => {
//     const {acc,acn,apn,chn,cur,amt,tcn,} = record;
//     const {csn,cco,mbn,idn} = record;
//     const {att,dcd,tdt,dsc,dtl,rfn,tri,rqi,rst,xsn,xtn,} = record;
//     const {nsc,noi} = record;
// //console.log('acn is ',acn);

//     const account = [
//       {t:'Provider',v:acn},
//       {t:'Service',v:apn},
//       {t:'Channel',v:chn},
//       {t:'Credit',v:cur},
//       {t:'Cost',v:amt},
//       {t:'Center',v:tcn},
//     ];

//     const customer = [
//       {t:'Customer',v:csn},
//       {t:'Code',v:cco},
//       {t:'Mobile',v:mbn},
//       {t:'ID Number',v:idn},
//     ];

//     const testing = [
//       {t:'Record Date',v:dcd},
//       {t:'Test Date',v:tdt},
//       {t:'Description',v:dsc},
//       {t:'Details',v:dtl},
//       {t:'Reference',v:rfn},
//       {t:'Test Reference',v:tri},
//       {t:'Request ID',v:rqi},
//       {t:'Result',v:rst},
//       {t:'Status',v:xsn},
//       {t:'Type',v:xtn},
//       {t:'Attempts',v:att},
//     ];

//     const notification  = [
//       {t:'Status',v:nsc}
//     ];

//     const rtn = [
//      {title:'Account',data:account},
//      {title:'Customer',data:customer},
//      {title:'Testing',data:testing},
//      {title:'Notification',data:notification},
//     ];

//     return rtn;
//   }

  showEmpty = (title:string) => {
    return (
      <Fragment>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{...s.column}}>
              <Typography sx={{...s.heading,...s.topheading}}>
                {title}
              </Typography>
            </Box>
            <Box sx={{...s.column}}>
              <Typography sx={{...s.secondaryHeading,...s.topheading}}>
                {'N/A'}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{...s.details}}>
            <Box>
              N/A
            </Box>
            <Box></Box>
          </AccordionDetails>
        </Accordion>
      </Fragment>        
    )
  }

  showStatus = (record:any) => {
    const {xsc} = record||{};
    if(!xsc) return this.showEmpty('Status');
    return (
      <Fragment>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{...s.column}}>
              <Typography sx={{...s.heading,...s.topheading}}>
                Status
              </Typography>
            </Box>
            <Box sx={{...s.column}}>
              <Typography sx={{...s.secondaryHeading,...s.topheading}}>
                {record.evc}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{...s.details}}>
            <Box>
              <Typography sx={{...s.secondaryHeading,...s.topheading}}>
                {record.nsc}
              </Typography>
            {(record.noi||[]).map( (infoitem:any,ii:number) => ( //TODO: sort stp in dessc
              <Box key={`tsi_${ii}`} sx={{...s.gridrow}}>
                <Box sx={{...s.gridcolumn30}}>
                  <Typography>
                    {infoitem.stp}
                  </Typography>
                </Box>
                <Box sx={{...s.gridcolumnauto}}>
                  <Typography sx={{...s.secondaryHeading2}}>
                    {infoitem.rst}
                  </Typography>
                </Box>
              </Box>
            ))}
            </Box>
            <Box></Box>
          </AccordionDetails>
        </Accordion>
      </Fragment>        
    )
  }

  showDetails = (rs:any) => {
    
    return (
      <Fragment>
      {rs.map( (rsitem:any,rid:number) => (
        <Box key={`rs_${rid}`}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{...s.heading}}>
                {rsitem.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{...s.details}}>
              <Box>
              {rsitem.data.map( (rec:any,idx:number) => (
                <Box key={`rs_${rid}_${idx}`}>
                  <Box sx={{...s.column}}>
                    <Typography sx={{...s.heading}}>
                      {rec.t}
                    </Typography>
                  </Box>
                  <Box sx={{...s.column}}>
                    <Typography sx={{...s.secondaryHeading}}>
                      {rec.v}
                    </Typography>
                  </Box>
                </Box>
              ))}
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
      ))}
      </Fragment>
    );
  }

  showHistory = (record:any) => {
    return (
      <Fragment>
        {(record.his && record.his.length>0)?
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{...s.heading,...s.topheading}}>
              History
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{...s.details}}>
              <Box>
                {record.his.map( (hisitem:any,i:number) => (
                  <Box key={`his_${i}`} sx={{...s.gridrow}}>
                  {/* <Box key={erritem.field} sx={{...s.gridrow}}> */}
                    <Box sx={{...s.gridcolumn30}}>
                      <Typography sx={{...s.heading}}>
                        <Box component='span'>{hisitem.stp}</Box>
                      </Typography>
                    </Box>
                    <Box sx={{...s.gridcolumnauto}}>
                      <Typography sx={{...s.secondaryHeading2}}>
                        <Box component='span'>{hisitem.rst}</Box>
                      </Typography>
                    </Box>
                    <Divider />
                  </Box>
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
        :""}
      </Fragment>
    );
  }

  showRequest = (record:any) => {
    /*
    dsc: "description"
    src: "Console"
    soi: 
    */
    return (
      <Fragment>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{...s.heading,...s.topheading}}>
              Request
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{...s.details}}>
            {/* <Box> */}
              {record.req.map((n:any) => {
                let sdoc:any = {};
                let vts:any = {};
                let docs = sdoc[n];
                let dockeys = Object.keys(docs);
                return dockeys.map( (vn,vi) => {
                  let docdata = docs[vn];
                  return (
                    <Box key={`doc_${vi}`}>
                      <Box sx={{...s.gridtitle}}>{vts[n]||n} - {vn}</Box> 
                      <Box>
                      {docdata.map( (dataitem:any,di:number) => {
                        return (
                          <Box key={`docdata_${di}`} sx={{...s.gridrow}}>
                          {/* <Box key={dataitem.field} sx={{...s.gridrow}}> */}
                            <Box sx={{...s.gridcolumn30}}>
                              <Typography sx={{...s.heading}}>
                                <Box component='span'>{dataitem.title}</Box>
                              </Typography>
                            </Box>
                            <Box sx={{...s.gridcolumnauto}}>
                              <Typography sx={{...s.secondaryHeading2}}>
                                <Box component='span'>{dataitem.value}</Box>
                              </Typography>
                            </Box>
                            <Divider />
                          </Box>
                        );
                      })} 
                      </Box>
                    </Box>
                  );  
                });
              })}
          </AccordionDetails>
        </Accordion>
      </Fragment>
    );
  }

  showResponse = (record:any) => {
    /**
     * loc: "(-0.3361599, 5.639948)"
        mbn: "+233500062919"
        msg: "↵1 Do you have headache?(No)↵2 Are you feeling feverish?(Yes)↵3 Are you coughing?(Yes)↵4 Are you having dry throats?(No)↵5 Would you like to book an appointment?(Yes)"
        rfn: "f93b5157-3f0e-4e12-b5dd-175f687091fc"
        stp: "2020-07-28T22:53:10+00:00"
     */
    return (
      <Fragment>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{...s.heading,...s.topheading}}>
              Response
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{...s.details}}>
            <Box sx={{...s.gridroot}}>
            {record.res.map( (valitem:any,vai:number) => {
              return (
                <Box key={`val_${vai}`} sx={{...s.gridrow}}>
                {/* <Box key={valitem.validation} sx={{...s.gridrow}}> */}
                  <Box sx={{...s.gridcolumn30}}>
                    <Typography sx={{...s.heading}}>
                      <Box component='span' sx={{...s.gridcontent}}>{valitem.title}</Box>
                    </Typography>
                  </Box>
                  <Box sx={{...s.gridcolumnauto}}>
                    <Typography sx={{...s.heading}}>
                      <Box component='span' sx={{...s.gridcontent}}>{valitem.validation}</Box>
                    </Typography>
                  </Box>
                  <Box sx={{...s.gridcolumn30}}>
                    <Typography sx={{...s.secondaryHeading2}}>
                      <Box component='span' sx={{...s.gridcontent}}>{valitem.result}</Box>
                    </Typography>
                  </Box>
                  <Divider />
                </Box>
              );
            })} 
            </Box>    
          </AccordionDetails>
        </Accordion>
      </Fragment>
    );
  }

  showDownloads = (record:any,classes:any) => {
    return (
      <Fragment>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{...s.heading,...s.topheading}}>
              Downloads
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{...s.details}}>
            <Box>
              <Box sx={{...s.iconsroot}}>
                  <Button variant="contained" sx={{...s.customicon}} onClick={this.onClick('pdf')}>
                    <PDFIcon titleAccess="PDF Download"/>
                  </Button>
                  <Button variant="contained" sx={{...s.customicon}} onClick={this.onClick('csv')}>
                    <CSVIcon titleAccess="CSV Download"/>
                  </Button>
                  <Button variant="contained" sx={{...s.customicon}} onClick={this.onClick('json')}>
                    <JSONIcon titleAccess="JSON Download" />
                  </Button>
                  <Button variant="contained" sx={{...s.customicon}} onClick={this.onClick('zip')}>
                    <ZIPIcon titleAccess="ZIP Download" />
                  </Button>
              </Box>
            </Box>
            <Box></Box>
          </AccordionDetails>
        </Accordion>
      </Fragment>
    );
  }

  onClick = (name:any) => () => {
    //var btn = meter.target;
    var {data,record,user} = this.props;
    var d = new Download('','');
    d.downloadFile(name,data,record); //user
  } 

  onClose = (meter:any) => {
    const {onClose} = this.props;
    this.setState({loaded:false});
    if(typeof onClose == 'function') onClose();
  }

  render() {
    const {tabname,open,recid,record,onClose,classes } = this.props;
    //const {data} = this.state;
    const name = tabname || 'Event';
    const title = `${name} Details`;
    const status = this.showStatus(record);
    //const recordset = this.procRecord(record);
    const recordset = this.processRecord(record);
    const details = this.showDetails(recordset);
    //const txnreq = this.showRequest(record,classes);
    //const txnres = this.showResponse(record,classes);
    const history = this.showHistory(record);
    const downloads = this.showDownloads(record,classes);
    // var sdoc = record.sdoc||{};
    // var vers = Object.keys(sdoc);
    // var vts = {'POI':'ID Verification','POA':'Address Verification'};
    return (
      <Fragment>
        <Dialog open={open}  sx={{...s.dialog}} slotProps={{paper: {sx:s.dialogcontent}}}>
          <DialogTitle sx={{...s.titlebar}}><ClosableBar onClose={this.onClose}>{title}</ClosableBar></DialogTitle>
          <DialogContent sx={{...s.dialogcontent}}>
            <Box sx={{...s.root}}>
              {/* call showStatus(record,classes) */}
              {/* {status} */}
              {/* call showDetails(record,classes) */}
              {details}
              {/* call showHistory(record,classes) */}
              {history}
              {/* call showRequest(record,classes) */}
              {/* call showResponse(record,classes) */}
              {/* call showDownloads(record,classes) */}
              {downloads}
              
              
              
            </Box>
          </DialogContent>
          {/* <DialogActions>
            <Button variant="contained" color="secondary" onClick={this.stopLoading}><CloseIcon/>Close </Button>
          </DialogActions> */}
        </Dialog>
      </Fragment>
    );
  }
}

export default Preview;
